module.exports = __webpack_public_path__ + "img/waba.d0289dc0.png";